import { Injectable } from '@angular/core';
import { switchMap, catchError, filter, take, tap } from 'rxjs/operators';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Observable, BehaviorSubject, throwError, EMPTY } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { ConnectorService } from '../services/connector.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private router: Router,
    private authService: AuthService
  ) {}

  //function which will be called for all http calls
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const noAuth =
      request.headers.has('No-Auth') &&
      request.headers.get('No-Auth') === 'true';

    if (noAuth) {
      return next.handle(request);
    }

    if (this.auth.token) {
      request = this.addToken(request, this.auth.token);
    }
    return next.handle(request).pipe(
      catchError((error) => {
        // No token provided
        if (
          error.status === 403 &&
          error.error.message === 'User is not logged in.'
        ) {
          this.authService.logout().subscribe((res) => {
            this.router.navigate(['/auth']);
          });
        }
        // Bad token provided
        if (error.status === 401) {
          this.authService.logout().subscribe((res) => {
            this.router.navigate(['/auth']);
          });
        }

        return throwError(error);
      })
    );
  }

  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    // return request with added auth jwt token
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
